import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { StatoNotaEnum } from "@app/shared/enum/stato-nota-enum";
import { ContatoreStatoNoteVO } from "@app/shared/vo/contatore-noteVO";
import { FiltroRicercaNotaVO } from "@app/shared/vo/filtro-ricerca-notaVO";
import { FiltroRicercaNotaStore } from "@app/store/filtro-ricerca-nota-store";
import { isNullOrUndefined } from "util";
import {TipoNotaLiquidazioneEnum} from "@enum/tipo-nota-liquidazione-enum";

type ItemContatoreNoteComponent = {
  label: string;
  icon: string;
  filtroStatoNota: StatoNotaEnum | StatoNotaEnum[];
  mostraInCarico?: boolean;
};

type ItemKeyValueContatoreNoteComponent = {
  key: string;
  value: ItemContatoreNoteComponent;
};

@Component({
  selector: "app-contatore-note",
  templateUrl: "./contatore-note.component.html",
})
export class ContatoreNoteComponent {
  /** Dati per un singolo tipo nota: { [stato: string]: ContatoreStatoNoteVO } */
  @Input() data: { [stato: string]: ContatoreStatoNoteVO };
  @Input() tipoNota: TipoNotaLiquidazioneEnum;
  @Input("zero-visible") zeroVisible: boolean = false;
  @Input("redirect") redirectEnable: boolean = false;

  constructor(
    private filtroRicercaNotaStore: FiltroRicercaNotaStore,
    private router: Router
  ) {}

  isVisibleGroup(group: string[]): boolean {
    return group.some((itemKey: string) => this.isVisibleItem(itemKey));
  }

  isVisibleItem(itemKey: string): boolean {
    const item: ItemContatoreNoteComponent = this.mappa[itemKey];
    const value: number = this.getValore(itemKey);
    return item && (this.zeroVisible || value > 0);
  }

  getValore(itemKey: string): number {
    if (!this.data) { return 0; }
    const item = this.mappa[itemKey];
    if (!item) { return 0; }
    const stati: StatoNotaEnum[] = Array.isArray(item.filtroStatoNota)
      ? item.filtroStatoNota
      : [item.filtroStatoNota];
    return stati.reduce((sum, s) => {
      const dati = this.data[s as unknown as string];
      return sum + (dati ? dati.totali : 0);
    }, 0);
  }

  getInCarico(itemKey: string): number {
    if (!this.data) { return 0; }
    const item = this.mappa[itemKey];
    if (!item) { return 0; }
    const stati: StatoNotaEnum[] = Array.isArray(item.filtroStatoNota)
      ? item.filtroStatoNota
      : [item.filtroStatoNota];
    return stati.reduce((sum, s) => {
      const dati = this.data[s as unknown as string];
      return sum + (dati ? dati.inCarico : 0);
    }, 0);
  }

  titleChip(itemKey: string): string {
    const item = this.mappa[itemKey];
    if (!item || !item.mostraInCarico) { return ""; }
    const inCarico = this.getInCarico(itemKey);
    if (inCarico === 0) { return "nessuno preso in carico"; }
    return inCarico === 1 ? "1 preso in carico" : inCarico + " presi in carico";
  }

  redirectToListaNota(item: ItemKeyValueContatoreNoteComponent): void {
    if (!this.redirectEnable) { return; }
    const filtro: FiltroRicercaNotaVO = new FiltroRicercaNotaVO();
    filtro.stato = Array.isArray(item.value.filtroStatoNota)
      ? item.value.filtroStatoNota
      : [item.value.filtroStatoNota];
    if (!isNullOrUndefined(this.tipoNota)) {
      filtro.tipologiaNota = this.tipoNota;
    }
    filtro.pageNumber = 0;
    filtro.direz = "desc";
    filtro.sort = "dataInserimento";
    this.filtroRicercaNotaStore.setFiltroRicercaNota(filtro);
    this.router.navigate(["/gestione-note/lista-note"]);
  }

  ordinamentoMappa: string[][] = [
    ["noteBozza"],
    ["noteInFirma"],
    ["noteFirmato"],
    ["noteApprovato", "noteRifiutoContabile"],
    ["notePagato", "noteRitirato"],
  ];

  mappa: { [key: string]: ItemContatoreNoteComponent } = {
    noteBozza: {
      label: "Bozza",
      icon: "edit",
      filtroStatoNota: StatoNotaEnum.BOZZA,
    },
    noteRifiutoContabile: {
      label: "Rifiuto contabile",
      icon: "assignment_ind",
      filtroStatoNota: StatoNotaEnum.RIFIUTO_CONTABILE,
    },
    noteInFirma: {
      label: "In firma",
      icon: "hourglass_full",
      filtroStatoNota: StatoNotaEnum.IN_FIRMA,
    },
    noteFirmato: {
      label: "Firmato",
      icon: "assignment_turned_in",
      filtroStatoNota: StatoNotaEnum.FIRMATO,
      mostraInCarico: true,
    },
    noteApprovato: {
      label: "Approvato",
      icon: "gavel",
      filtroStatoNota: StatoNotaEnum.APPROVATO,
      mostraInCarico: true,
    },
    notePagato: {
      label: "Pagato",
      icon: "done_all",
      filtroStatoNota: StatoNotaEnum.PAGATO,
    },
    noteRitirato: {
      label: "Ritirato",
      icon: "assignment_ind",
      filtroStatoNota: StatoNotaEnum.RITIRATO,
    },
  };
}
